import { NotFound } from "@p0security/frontend-core/react";
import { Spin } from "@p0security/ui";
import { Outlet } from "react-router";

import { useAgenticGateway } from "./AgenticGateway";

/** Prevents direct access to Agentic Access until an agentic gateway is installed. */
export const AgenticGatewayGuard: React.FC = () => {
  const { hasGateway, loading } = useAgenticGateway();

  if (loading) {
    return (
      <div className="flex min-h-64 items-center justify-center">
        <Spin size="large" aria-label="Checking agentic gateway" />
      </div>
    );
  }

  return hasGateway ? <Outlet /> : <NotFound />;
};
